import React from 'react';
import { format } from 'date-fns';
import { parseUTC } from 'core/utils';
import OrderSoonIcon from './OrderSoonIcon';
import {
	Wrapper, Text,
} from './orderSoonStyles';

export const formatDate = (d) => {
	const dt = parseUTC(d);
	return format(dt, 'MMMM do');
};

const OrderSoon = ({ initialShipmentString }) => {
	const msg = initialShipmentString.length === 0 
		? "The cutoff for this month's shipment is almost here!"
		: initialShipmentString;  
	return (
		<Wrapper>
			<OrderSoonIcon />
			<Text><span>Order Soon</span> - {msg}</Text>
		</Wrapper>
	); 
};

export default OrderSoon;